const colorPrimary = '#38C9F2';
const colorSecondary = '#F8C9F2';

const settings = {
  brandGradient: `linear-gradient(133deg, ${colorPrimary} 0%, ${colorSecondary} 100%)`,
};

export default settings;
